/* W-02 budget: KPI strip, the expense table and charts beside goals, dues and categories. */
.page {
  min-height: 100vh;
}
.pad {
  padding: var(--dimension-space-4) var(--gutter);
}
.padS {
  margin: 0;
  padding: var(--dimension-space-3) var(--dimension-space-5);
}
.muted {
  color: var(--color-text-secondary);
}
.owe,
.due {
  color: var(--color-status-danger);
}
.top {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: end;
  gap: var(--dimension-space-4);
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.title {
  margin: 0;
}
.filters,
.cats,
.scope {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--dimension-space-1);
}
/* Destination pills (W-02), as the apps' chips. */
.chip {
  height: 32px;
  padding: 0 var(--dimension-space-3);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  border-radius: 999px;
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
  cursor: pointer;
}
.chipOn {
  background: var(--color-surface-inverse);
  border-color: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.notice {
  margin: 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  background: var(--color-surface-sunken);
}
.kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.kpi {
  display: grid;
  gap: var(--dimension-space-1);
  align-content: start;
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.kpi:first-child {
  border-left: 0;
}
.kpiRow,
.goalHead,
.panelHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--dimension-space-2);
}
.grid {
  display: grid;
  grid-template-columns: 1fr 380px;
}
.main {
  min-width: 0;
}
.side {
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.block {
  padding-bottom: var(--dimension-space-4);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.panelHead {
  padding: var(--dimension-space-3) var(--dimension-space-5);
  border-bottom: var(--dimension-line-control) solid var(--color-text-primary);
}
.panelHead h2 {
  margin: 0;
}
.panel {
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.goal,
.cat {
  display: grid;
  gap: var(--dimension-space-1);
  padding: var(--dimension-space-3) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
/* Label, bar and amount on one line (W-02). */
.cat {
  grid-template-columns: 96px 1fr auto;
  align-items: center;
  gap: var(--dimension-space-3);
  border-bottom: 0;
  padding-top: var(--dimension-space-1);
  padding-bottom: var(--dimension-space-1);
}
.catAmount {
  text-align: right;
}
.cat:last-child {
  padding-bottom: var(--dimension-space-4);
}
.meter {
  height: 6px;
  background: var(--color-surface-sunken);
}
.meter i {
  display: block;
  height: 100%;
  background: var(--color-text-primary);
}
.meter i.over {
  background: var(--color-status-danger);
}
.icon {
  border: 0;
  background: none;
  color: var(--color-text-tertiary);
  cursor: pointer;
  padding: var(--dimension-space-1);
  opacity: 0;
}
/* Delete shows on the row you're on, not on every row; always on touch screens. */
.icon:focus-visible,
tr:hover .icon,
li:hover .icon,
.goal:hover .icon {
  opacity: 1;
}
@media (hover: none) {
  .icon {
    opacity: 1;
  }
}
.icon:hover {
  color: var(--color-status-danger);
}
.select {
  color: var(--color-text-primary);
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  padding: var(--dimension-space-1) var(--dimension-space-2);
}
:where(.select) {
  font: inherit;
}
.num {
  text-align: right;
}
.tableWrap {
  overflow-x: auto;
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table th,
.table td {
  padding: var(--dimension-space-2);
  text-align: left;
  white-space: nowrap;
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.table th:first-child,
.table td:first-child {
  padding-left: var(--dimension-space-5);
}
.table th {
  color: var(--color-text-tertiary);
}
.table tbody tr {
  cursor: pointer;
}
.table tbody tr:hover,
.table tbody tr:focus-visible {
  background: var(--color-surface-sunken);
}
.table td:last-child,
.table th:last-child {
  padding-right: var(--dimension-space-5);
}
.spark {
  display: flex;
  align-items: flex-end;
  gap: var(--dimension-space-1);
  height: 120px;
  padding: var(--dimension-space-4) var(--dimension-space-5) 0;
}
.spark i {
  flex: 1;
  background: var(--color-text-primary);
}
.spark i.todayBar {
  background: var(--color-surface-signal);
  box-shadow: inset 0 0 0 1px var(--color-text-primary);
}
.spark i.future {
  background: var(--color-border-hairline);
}
.sparkAxis {
  display: flex;
  justify-content: space-between;
  padding: var(--dimension-space-1) var(--dimension-space-5) 0;
}
.plain {
  margin: 0;
  padding: 0;
  list-style: none;
}
.settleRow {
  display: grid;
  grid-template-columns: 56px 1fr auto 96px auto;
  align-items: center;
  gap: var(--dimension-space-3);
  padding: var(--dimension-space-2) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}

.amountRow {
  display: flex;
  gap: var(--dimension-space-2);
  align-items: stretch;
}
.amount {
  flex: 1;
  min-width: 0;
  padding: 0 var(--dimension-space-2);
  text-align: right;
  color: var(--color-text-primary);
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
}
@media (max-width: 899px) {
  .top,
  .grid {
    grid-template-columns: 1fr;
  }
  .kpis {
    grid-template-columns: 1fr 1fr;
  }
  .side {
    border-left: 0;
  }
}
.check {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  color: var(--color-text-primary);
}
